import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalAgregarCategoria from './AgregarCategoriaElementosDiseno';
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class CategoriaElementosDiseno extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      NombreCategoria: '',
      DescripcionCategoria: '',
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombreCategoria: false,
      errorDescripcion: false,
      cetegoriasElementos: [],
      categoriasElementosMostrar: [],
      entroFiltrar: false,
      notificacion: false
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarCategoriaElementosDiseno = this.eliminarCategoriaElementosDiseno.bind(this);
    this.filtrarCategoriaElementosDisenos = this.filtrarCategoriaElementosDisenos.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerFinCategorias();
    this.obtenerAllCategorias();
  }

  //Obtener todos los registros guardados
  obtenerAllCategorias() {
    fetch(Globales.Url + 'ElementosDiseno/CategoriaElementosDiseno/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ categoriaElementos: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ categoriaElementos: data.data });
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerFinCategorias() {
    fetch(Globales.Url + 'ElementosDiseno/CategoriaElementosDiseno/ListaCategoriasElementosDiseno', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else { //Obtuvo los registros correctamente
            if(data.data != null){
              this.setState({ categoriasElementosMostrar: data.data });
            }else{
              this.setState({ categoriasElementosMostrar: [] });
            }
          }
        })
        .catch(err => console.error(err));
    });
  }

  //Función de editar registro
  editarCategoriaElementosDiseno(id, Nombre, Descripcion) {
    this.setState({ _id: id, NombreCategoria: Nombre, DescripcionCategoria: Descripcion, op: 1, showAgregar: true, Titulo: "Editar Categoría de Elemento de Diseño" });
  }

  //Función de eliminar registro
  eliminarCategoriaElementosDiseno(id) {
    fetch(Globales.Url + 'ElementosDiseno/CategoriaElementosDiseno/BajaCategoriaElementosDiseno', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification("tr");
        this.obtenerFinCategorias();
        this.limpiar();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarCategoriaElementosDiseno(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarCategoriaElementoDiseno = () => {
    this.setState({ showAgregar: true, Titulo: "Nueva categoría Elementos de Diseño", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalMateriaPrima = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nueva categoría Elementos de Diseño", NombreCategoria: "", DescripcionCategoria: "", op: 0 })
    this.obtenerFinCategorias();
    this.obtenerAllCategorias();
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarCategoriaElementosDisenos() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreCategoria.trim() == '') {
      this.setState({ errorNombreCategoria: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreMateria: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombreCategoria: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'ElementosDiseno/CategoriaElementosDiseno/FiltrarCategoriaElementosDisenoNombre', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify(this.state)
      }
      ).then(res => res.json())
        .then(data => {

          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.mensaje.length == 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning",categoriasElementosMostrar:[], mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', categoriasElementosMostrar: data.mensaje, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreCategoria: '', entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.obtenerFinCategorias();
    this.obtenerAllCategorias();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.categoriaElementos.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerFinCategorias();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.categoriaElementos.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.categoriaElementos.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerFinCategorias();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (!global.entrar) {
        this.setState({ mensaje: 'No hay más categorías de elementos de diseño para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }

  validarDescripcion(descripcion) {
    var nombre = ''
    if (descripcion === '') {
      nombre = 'Sin Descripción'
    } else {
      nombre = descripcion
    }
    return nombre
  }

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <ModalAgregarCategoria
          Titulo={this.state.Titulo}
          NombreCategoria={this.state.NombreCategoria}
          DescripcionCategoria={this.state.DescripcionCategoria}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalMateriaPrima}
          op={this.state.op}
          classes={this.props}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Categoría de Elementos de Diseño</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Buscar categoría"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreCategoria,
                        name: "NombreCategoria",
                        id: "NombreCategoria",
                        type: "text",
                        error: this.state.errorNombreCategoria
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarCategoriaElementosDisenos()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />Limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarCategoriaElementoDiseno()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de categoriaElementos */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={7}>
                    <h4 className="pull-left">Lista de Categoría de Elementos de Diseño</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Nombre Categoría</th>
                        <th className="center">Descripción</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.categoriasElementosMostrar.map(categoria => {
                          return (
                            <tr key={categoria._id}>
                              <td>{categoria.NombreCategoria}</td>
                              <td>{this.validarDescripcion(categoria.DescripcionCategoria)}</td>
                              <td className="pull-right">
                                <Button color="warning" round justIcon size="sm" onClick={() => this.editarCategoriaElementosDiseno(categoria._id, categoria.NombreCategoria, categoria.DescripcionCategoria)}><Edit /></Button>
                                <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(categoria._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>}

              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Categoría de Elemento de Diseño"}
            Cuerpo={"¿Está seguro que desea eliminar la categoría de elementos de diseño?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(CategoriaElementosDiseno);